<template lang="pug">
  .display-contents
    slot(
      :loading="loading"
      :server-data="responseData"
      :select-props="selectProps"
      :search="search"
      :load-more-items="loadMoreItems"
      :pagination="pagination"
      :has-more="hasMore"
      :init="init"
    )
</template>

<script>
import _ from 'lodash';

const DEBOUNCE_DELAY = 300;

export default {
  props: {
    method: { type: Function, required: true },
    query: { type: Object, default: () => ({}) },
    noInit: { type: Boolean, default: false },
    dadata: { type: Boolean, default: false },
    serializeData: { type: Function, default: (data) => data },
    itemValue: { type: String, default: 'id' },
    itemText: { type: String, default: 'name' },

    // Deprecated. Use query instead. Will be removed
    searchFieldName: { type: String, default: 'q' },

    responseDataSerializer: { type: Function, default: (serverData) => serverData },
  },
  data() {
    return {
      serverData: [],
      pagination: null,
      searchInput: null,
      loading: !this.noInit,
      initialized: false,
    };
  },
  computed: {
    selectProps() {
      return {
        // items: (this.dadata ? this.serverData.items : this.serverData.response) || [],
        items: this.serverData || [],
        'item-text': this.itemText,
        'item-value': this.itemValue,
        loading: this.loading,
      };
    },
    responseData() {
      return this.responseDataSerializer(this.serverData);
    },
    preparedQuery() {
      return { ...this.query, [this.searchFieldName]: this.searchInput };
    },
    hasMore() {
      return this.pagination && this.pagination.page < this.pagination.total;
    },
  },
  watch: {
    preparedQuery() {
      this.pagination = null;
      this.debounced();
    },
  },
  created() {
    this.debounced = _.debounce(this.init, DEBOUNCE_DELAY);
    if (!this.noInit) this.debounced();
  },
  methods: {
    async init(page) {
      this.loading = true;
      this.pagination = null;
      const resp = await this.loadItems(page);
      this.serverData = this.exctractData(resp);
      if (!this.initialized) {
        this.$emit('init', this.serverData);
        this.initialized = true;
      }
      this.loading = false;
    },
    search(val) {
      this.searchInput = val;
    },
    exctractData(responseServerData) {
      const {
        item,
        items,
        pagination,
        data,
        loadMore,
      } = responseServerData;
      if (pagination) {
        this.pagination = pagination;
      }
      if (loadMore) this.loadMoreItems = loadMore;
      if (item) return item;
      if (items) return items;
      if (data) return this.serializeData(this.dadata ? data.suggestions : data.data);
      return null;
    },
    loadItems(page = null) {
      return this.method({ ...this.preparedQuery, page });
    },
    async loadMoreItems() {
      if (this.hasMore) {
        this.loading = true;
        this.pagination.page += 1;
        const resp = await this.loadItems(this.pagination.page);
        this.loading = false;

        this.serverData = [...this.serverData, ...resp.data.data];
      }
    },
    updateItem(idx, val) {
      this.serverData[idx] = val;
    },
  },
};
</script>
